import React, {Component} from 'react';
import FileIcon from './components/FileIcon';
import {FormControl, FormGroup, Modal} from 'react-bootstrap';
import './style.css';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import LoadingIcon from "../../../../components/LoadingIcon";
import FileViewer from "../../components/FileViewer";
import mobileCheck from '../../../../services/mobileCheck';


class Files extends Component{

    static contextTypes = { api: PropTypes.object };

    loadingId = "@Class.Files.appFiles.get";

    constructor( props, context ){
        super( props, context );

        context.api.clearProperty( "appFiles" );

        this.state = {
            actualFolder: props.appFilesRoot,
            tree:[],
            newFolder:'',
            fileNameToSearch:''
        };

        this.context = context;
        if( !props.appFilesRoot )
            context.api.appFiles.getRoot( this.loadingId )
                .then(( root )=>{
                    this.setState( {actualFolder: root} );
                    this.loadFolderContents( root );
                });
        else
            this.loadFolderContents( props.appFilesRoot );
    }

    loadFiles = ()=> this.context.api.appFiles.get(0,200,this.loadingId,{originalName:this.state.fileNameToSearch,parent:this.state.actualFolder.id});

    loadFolderContents = ( folder )=>{
        this.context.api.clearProperty( "appFiles" );
        this.context.api.appFiles.get(  0, 200, this.loadingId, {parent:folder.id} );
    };

    onSelect = ( file )=>{

        //Selected folder
        if( file.isFolder ){

            this.loadFolderContents( file );
            this.setState( {
                tree: [ ...this.state.tree, {...this.state.actualFolder}],
                actualFolder: file
            } );
        }
        //Selected file
        else{
            if( mobileCheck() && file.mimeType.indexOf( 'pdf' ) !== -1 ){
                window.open( this.context.api.appFiles.getUrl( file.id ) );
            }
            else {
                this.setState({viewFile: file});
            }
        }
    };

    goToParent = ()=>{

        if( !this.state.tree.length ) return;

        const newTree = [...this.state.tree];
        const newActual = newTree.pop();

        this.loadFolderContents( newActual );
        this.setState( {
            tree: newTree,
            actualFolder: newActual
        } );
    };

    loadingNewFolder = "@Class.File.appFiles.create.folder";

    canEdit = ()=>{

        if(!this.props.me || !this.props.me.role )
            return false;

        const role = this.props.me.role.name;

        const editRoles = ['SUPER_ADMIN'];

        return editRoles.indexOf(role) !== -1;
    };

    createFolder = ()=>{

        const name = this.state.newFolder.trim();

        if( !name )
            return;

        this.context.api.appFiles.create( this.state.actualFolder.id, true, name, this.folderCover, this.loadingNewFolder )
            .then(()=>{
                this.setState({
                    creatingFolder:false,
                    newFolder:''
                })
            })
    };

    uploadFile = ({target:{files}})=>{

        if(!files || !files.length )
            return;

        const file = files[0];

        this.context.api.appFiles.create( this.state.actualFolder.id, false, undefined, file );

    };

    deleteFile = ( file )=> {
        this.setState( {deletingFile:file} );
    };

    confirmDeleteFile = ()=>{
        this.context.api.appFiles.delete(this.state.deletingFile.id);
        this.setState( {deletingFile:false} );
    };

    openCreateFolder = ()=>{
        this.setState({creatingFolder:true});
        this.folderCover = null;
    };

    folderCoverChange = (e)=>{
        if( e.target.files && e.target.files.length )
            this.folderCover = e.target.files[0];
        else
            this.folderCover = null;
    };

    onFilenameChange = (e) => this.setState({ 'fileNameToSearch':e.currentTarget.value },()=>this.loadFiles());

    getValue = ( name ) =>{
        return this.state[name]? this.state[name] : '';
    };

    render(){

        const canEdit = this.canEdit();

        return(
            <div className="container-fluid Files">
                <div className="row">
                    <div className="col-md-12">
                        <FormGroup controlId='search'>
                            <FormControl
                                placeholder='Buscar archivo o carpeta'
                                name='fileNameToSearch'
                                value={ this.getValue('fileNameToSearch') }
                                onChange={ this.onFilenameChange }
                            />
                        </FormGroup>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">
                                    { !this.state.actualFolder || this.state.actualFolder.name === "_root" ? '/' : this.state.actualFolder.originalName } &nbsp;
                                    { this.state.tree.length? <i className='fa fa-level-up' onClick={this.goToParent} />:null }
                                </h4>
                                {canEdit?
                                <div className='actions-container'>
                                    <span className='action-but' onClick={this.openCreateFolder}> <i className='fa fa-folder-open-o' /> Nueva carpeta</span>
                                    <span className='action-but'> <i className='fa fa-files-o' />  Subir archivo <input type='file' onChange={this.uploadFile} /></span>
                                </div>
                                    :null}
                            </div>
                            <div className="card-content">

                                <div className='files-container'>

                                    {this.props.appFiles.map( (file)=>
                                        <FileIcon
                                            file={file}
                                            key={file.id}
                                            onSelect={this.onSelect}
                                            onDelete={canEdit? this.deleteFile : null}
                                            cover={file.isFolder && file.size? this.context.api.appFiles.getUrl( file.id ) : null }
                                        />
                                    )}

                                    {this.props.loadingIds[this.loadingId]?
                                        <h5><LoadingIcon/> Cargando...</h5>:
                                    null}
                                    {this.props.appFiles.length === 0 && !this.props.loadingIds[this.loadingId]?
                                        <h5>Parece que no hay ningún archivo aquí</h5>:
                                    null}
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

                {/* New folder Modal */}
                {this.state.creatingFolder?
                    <Modal
                        show={true}
                        onHide={()=>this.setState({creatingFolder:false})}
                        bsSize='small'
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                Nueva carpeta
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>Nombre de la carpeta:</p>
                            <input className='form-control'
                                   placeholder='Nombre'
                                   onChange={({target})=>this.setState({newFolder:target.value})}
                                   value={this.state.newFolder}
                            />
                            <p>Selecciona una portada:</p>
                            <input type='file' onChange={this.folderCoverChange}/>
                        </Modal.Body>

                        <Modal.Footer>
                            <button
                                type='button'
                                onClick={()=>this.setState({creatingFolder:false})}
                                className='btn btn-danger pull-left'
                                disabled={this.props.loadingIds[ this.loadingNewFolder]}
                            >
                                Cancelar
                            </button>
                            <button
                                type='submit'
                                className='btn btn-success'
                                onClick={this.createFolder}
                                disabled={this.props.loadingIds[ this.loadingNewFolder]}
                            >
                                Crear
                            </button>
                        </Modal.Footer>

                    </Modal>
                    :null}
                {/* END New folder Modal */}

                {/* Delete file Modal */}
                {this.state.deletingFile?
                    <Modal
                        show={true}
                        onHide={()=>this.setState({deletingFile:false})}
                        bsSize='small'
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                Eliminar {this.state.deletingFile.isFolder? "carpeta":"archivo"}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>¿ Estás seguro que deseas borrar
                                {this.state.deletingFile.isFolder?
                                    (" la carpeta " + this.state.deletingFile.name + " y todo su contenido"):
                                    " el archivo " + this.state.deletingFile.originalName}
                            ?</p>
                        </Modal.Body>

                        <Modal.Footer>
                            <button
                                type='button'
                                onClick={()=>this.setState({deletingFile:false})}
                                className='btn btn-danger pull-left'
                            >
                                Cancelar
                            </button>
                            <button
                                type='submit'
                                className='btn btn-danger'
                                onClick={this.confirmDeleteFile}
                            >
                                Borrar
                            </button>
                        </Modal.Footer>

                    </Modal>
                    :null}
                {/* END delete file Modal */}

                {/* File viewer modal */}
                {this.state.viewFile?
                    <Modal
                        show={true}
                        onHide={()=>this.setState({viewFile:false})}
                        bsSize='lg'
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                {this.state.viewFile.originalName}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <FileViewer
                                src={this.context.api.appFiles.getUrl( this.state.viewFile.id )}
                                name={this.state.viewFile.originalName}
                            />
                        </Modal.Body>

                        <Modal.Footer>
                            <button
                                type='button'
                                onClick={()=>this.setState({viewFile:false})}
                                className='btn btn-danger pull-left'
                            >
                                Cerrar
                            </button>
                            <a href={this.context.api.appFiles.getDownloadUrl( this.state.viewFile.id )} target='_blank' rel='noopener'>
                                <button className='btn btn-success'>
                                    Descargar
                                </button>
                            </a>
                        </Modal.Footer>

                    </Modal>
                    :null}
                {/* END  File viewer modal */}

            </div>
        );
    }

}

const mapStateToProps = ( {api:{me, appFilesRoot, appFiles = []}, loadingIds} )=>{
    return { me, appFilesRoot, appFiles, loadingIds };
};

export default connect( mapStateToProps )( Files );


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Files/index.js